import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import sun1 from './img/sun1.png';
import sun2 from './img/sun2.png';
import sun3 from './img/sun3.png';
import car_logo from './img/car_logo.png';
import gift from './img/gift.png';
import { useMediaQuery } from "react-responsive";

import ray_img from './img/ray.png';
import casper_img from './img/casper.png';

import casper_bg from './img/casper_bg.png';
import ray_bg from './img/ray_bg.png';
import ray_icon from './img/ray_icon.png';
import imgFrameBang3 from './img/main_img_3.png';

function Sungard({setBannerType}){
    const history = useHistory();

    useEffect(()=> {
        setBannerType('sun')

        return () => {
            if(window.location.href === 'http://localhost:3000/' || window.location.href === 'https://abys-service.co.kr/'){
                setBannerType('main');
            }
        }
    },[])

    const onClick = (typed) => {
        setBannerType('')
        history.push(`sunlist?type=${typed}`)
    }

    const isPc = useMediaQuery({
        query : "(min-width:768px)"
    });
    const isMobile = useMediaQuery({
        query : "(max-width:767px)"
    });

    return (
        <div className="k-wrapper py-5">
            <div>
                <p className="container top-title font-weight-bold mb-5" style={{color:'#585858',fontSize:'16px'}}>
                썬가드하이퍼 신차패키지는 고객님 차량의 품격을 높여주는 서비스 입니다.<br />
                썬팅에서 블랙박스, 유리막코팅, PPF까지...고품질의 서비스를 합리적인 가격으로 만나보세요! 
                </p>
            </div>
            <div className="container px-0">
                <div className="row px-0 py-5">
                    <div className="col-md-4 col-6"><img src={casper_img} className="w-100 pointer" onClick={() => history.push('/casper')}/></div>
                    <div className="col-md-4 col-6"><img src={ray_img} className="w-100 pointer" onClick={() => history.push('/ray')} /></div>  
                </div>
            </div>
        </div>
    )
}

export default Sungard;